module.exports = require("moment");


//////////////////
// WEBPACK FOOTER
// external "moment"
// module id = 11
// module chunks = 0